import * as React from 'react';
import { useStyles, useId, noop } from '@sravni/react-utils';
import { STAR_SIZES } from '../../../constants/sizes.js';
import modules_d76667db from '../styles/Rate.module.less.js';
import { Star } from './Star.js';

const fractionalIndex = (event) => {
    const x = event.clientX - event.currentTarget.getBoundingClientRect().left;
    const offset = x / event.currentTarget.offsetWidth;
    if (offset <= 0.3) {
        return 0.3;
    }
    if (offset > 0.3 && offset <= 0.5) {
        return 0.5;
    }
    if (offset > 0.5 && offset <= 0.8) {
        return 0.8;
    }
    return 1;
};
/**
 * @description A quick rating operation on something
 *
 * @component
 * @example
 * ```jsx
 * <Rate fractional defaultValue={4} count={5} size={36}>
 * ```
 */
const Rate = React.forwardRef((props, ref) => {
    const { fractional = false, count = 5, defaultValue, value, size = STAR_SIZES.S20, disabled, onChange, className, emptyColor = 'light', ...restProps } = props;
    const cx = useStyles(modules_d76667db);
    const id = useId('rate');
    const classNames = cx(className, 'container', {
        [`size-${size}`]: size,
        disabled,
    });
    const [innerValue, setInnerValue] = React.useState(defaultValue || value || 0);
    const [hoverIndex, setHoverIndex] = React.useState(null);
    const handleHover = React.useCallback((event, index) => {
        const value = fractional ? index + fractionalIndex(event) : index + 1;
        setHoverIndex(value);
    }, [fractional]);
    const handleMouseLeave = React.useCallback(() => {
        setHoverIndex(null);
    }, []);
    const handleClickRate = React.useCallback((event, index) => {
        const value = fractional ? index + fractionalIndex(event) : index + 1;
        setInnerValue(value);
        onChange?.(value);
    }, [fractional, onChange]);
    const stars = React.useMemo(() => Array.from(new Array(count)).map((_, index) => (React.createElement(Star
    // eslint-disable-next-line react/no-array-index-key
    , { 
        // eslint-disable-next-line react/no-array-index-key
        key: `${id}-${index}`, index: index, value: hoverIndex === null ? innerValue : hoverIndex, fractional: fractional, disabled: disabled, size: size, onHover: handleHover, onClick: handleClickRate, emptyColor: emptyColor }))), [id, hoverIndex, innerValue, count, disabled, fractional, size, emptyColor, handleClickRate, handleHover]);
    React.useEffect(() => {
        value && setInnerValue(value);
    }, [value]);
    return (React.createElement("div", { ref: ref, "data-qa": "Rate", className: classNames, ...restProps, onMouseLeave: disabled ? noop : handleMouseLeave }, stars));
});
Rate.displayName = 'Rate';

export { Rate };
//# sourceMappingURL=Rate.js.map
